import React from 'react';
import { Column } from '../contexts/column.context';
import { Row } from '../contexts/row.context';
import { STRIP_WIDTH, TOP_PLOT_FOOTER_HEIGHT } from '../utils/graph.utils';
import { StripAxis } from './StripAxis';

const NOISE_BAR_HEIGHT = (TOP_PLOT_FOOTER_HEIGHT * 2) / 3;

interface Props {
  offset?: number;
}

export const AxisContainer: React.FC<Props> = ({ offset = 0 }) => {
  return (
    <Row height={NOISE_BAR_HEIGHT}>
      <Column width={STRIP_WIDTH} offsetLeft={offset}>
        <StripAxis />
      </Column>
    </Row>
  );
};
